import {createContext, useContext} from "react"

import type {AyaClientEnv} from "~/lib/env.server"

export const ClientEnvContext = createContext<AyaClientEnv>({
  messageCharacterLimit: 3000,
  supportEmail: "email@example.com",
  newUserFeedbackFormId: "form-id",
  environment: "development",
})

export const useEnv = (): AyaClientEnv => useContext(ClientEnvContext)
